import React from 'react'
import Chart from 'react-apexcharts'
import moment from 'moment'
import { useQuery, useCallback, useState, useMemo } from 'sb-hooks'

import CardWithGraph from 'components/dashboard/CardWithGraph/CardWithGraph'

import s from './ChartWidget.scss'


const periods = [
  'DAY',
  'WEEK',
  'MONTH',
  'YEAR',
]


const ChartWidget = ({ title, sensorId }) => {
  const [ query, setQuery ] = useState(periods[0])

  const { data, isFetching } = useQuery({
    url: `/smartSensor/rest/sensor/${sensorId}?period=${query}`,
  })

  const handleChange = useCallback((selectedTab) => {
    if (typeof selectedTab === 'object') {
      setQuery(`from=${selectedTab.from}&to=${selectedTab.to}`)
    }
    else {
      setQuery(`${periods[selectedTab]}`)
    }
  }, [])

  const date = useMemo(() => {
    const queryFrom = /from=/.test(query) && query.replace(/&to=.*/, '').replace('from=', '')
    const queryTo   = /from=/.test(query) && query.replace(/.*&to=/, '')

    const to = ({
      [periods[0]]: moment(),
      [periods[1]]: moment().endOf('week'),
      [periods[2]]: moment().endOf('month'),
    })[query]

    const from = ({
      [periods[0]]: moment(),
      [periods[1]]: moment().add({ days: -7 }),
      [periods[2]]: moment().startOf('month'),
    })[query]

    return {
      from: (queryFrom ? moment(queryFrom, 'YYYY-MM-DD') : moment(from)),
      to: (queryTo ? moment(queryTo, 'YYYY-MM-DD') : moment()),
    }
  }, [ query ])

  return (
    <CardWithGraph
      title={title}
      withPeriodTab={false}
      date={date}
      loading={isFetching}
      onSelect={handleChange}
    >
      {
        Boolean(data && data.measures && data.measures.length) && (
          <Chart
            className={s.chart}
            options={{
              chart: {
                stacked: true,
                toolbar: {
                  show: false,
                },
                zoom: {
                  enabled: false,
                },
              },
              colors: data.measures.length <= 5 ? [ '#336be2', '#966fff', '#c2ff8b', '#ffa77f', '#dedede' ] : undefined,
              dataLabels: {
                enabled: false,
              },
              stroke: {
                curve: 'smooth',
              },
              fill: {
                type: 'gradient',
                gradient: {
                  opacityFrom: 0.6,
                  opacityTo: 0.8,
                }
              },
              legend: {
                position: 'right',
                offsetY: -10,
              },
              xaxis: {
                type: 'datetime'
              },
              yaxis: {
                labels: {
                  formatter: (value) => value.toFixed(2),
                },
              },
            }}
            series={[{
              name: data.sensor.units,
              data: data.measures.map(({ value, ts }) => [
                moment(ts).toDate().getTime(),
                value,
              ])
            }]}
            type="area"
            height="210"
          />
        )
      }
    </CardWithGraph>
  )
}


export default ChartWidget
